import React, { useContext, useState, useEffect } from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  IconButton,
  TextField,
  Box,
} from "@mui/material";
import { FilterList } from "@mui/icons-material";
import { WarehouseMasterContext } from "../../context";

const headCells = [
  { id: "id", label: "ID" },
  { id: "name", label: "Warehouse Name" },
  { id: "contact_mobile", label: "Contact Mobile" },
  { id: "total_emp", label: "Employees" },
  { id: "city", label: "City/State" },
  { id: "pincode", label: "Pincode" },
  { id: "area_per_sqft", label: "Area (sqft)" },
  { id: "merchant_assign_count", label: "Merchant Assign" },
  { id: "created_at", label: "Created At" },
  { id: "status", label: "Status" },
  { id: "action", label: "Action" },
];

// columns that have filters
const filterableColumns = [];

export default function WarehouseTableHead({
  order,
  orderBy,
  onRequestSort,
}) {
  const { allData, setAllWarehouse } = useContext(WarehouseMasterContext);

  const [filters, setFilters] = useState({});
  const [showFilters, setShowFilters] = useState({});

  // handle sort click
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  // handle input change
  const handleFilterChange = (e, key) => {
    const { value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // toggle filter field visibility
  const toggleFilter = (key) => {
    setShowFilters((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // apply filters
  useEffect(() => {
    if (!allData?.data) return;
    let filteredData = [...allData.data];

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value.trim() !== "") {
        filteredData = filteredData.filter((item) => {
          const cellValue = item[key]?.toString().toLowerCase() || "";
          return cellValue.includes(value.toLowerCase());
        });
      }
    });

    setAllWarehouse(filteredData);
  }, [filters, allData, setAllWarehouse]);

  const stickyActionStyle = {
    position: 'sticky',
    right: 0,
    backgroundColor: '#fff',
    borderLeft: '1px solid #ddd',
    boxShadow: 'inset 4px 0 8px -4px rgba(0, 0, 0, 0.2)',
    zIndex: 3,
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          const isFilterable = filterableColumns.includes(headCell.id);
          const isAction = headCell.id === "action";

          return (
            <TableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={isAction ? stickyActionStyle : { whiteSpace: 'nowrap' }}
            >
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                </TableSortLabel>

                {isFilterable && (
                  <IconButton
                    size="small"
                    onClick={() => toggleFilter(headCell.id)}
                    sx={{
                      ml: 1,
                      color: showFilters[headCell.id] ? "primary.main" : "inherit",
                    }}
                  >
                    <FilterList fontSize="small" />
                  </IconButton>
                )}
              </Box>
            </TableCell>
          );
        })}
      </TableRow>

      {Object.values(showFilters).some(Boolean) && (
        <TableRow>
          {headCells.map((headCell) => {
            const showFilter =
              filterableColumns.includes(headCell.id) && showFilters[headCell.id];
            const isAction = headCell.id === "action";

            return (
              <TableCell
                key={`${headCell.id}-filter`}
                sx={{
                  ...(isAction && stickyActionStyle),
                  paddingTop: 0,
                  paddingBottom: 0,
                }}
              >
                {showFilter ? (
                  <TextField
                    variant="standard"
                    placeholder={`Search By ${headCell.label}`}
                    value={filters[headCell.id] || ""}
                    onChange={(e) => handleFilterChange(e, headCell.id)}
                    fullWidth
                    size="small"
                    sx={{
                      fontSize: '0.65rem',
                      '& .MuiInputBase-input': {
                        fontSize: '0.75rem',
                        padding: '3px 0 3px 8px',
                      }
                    }}
                  />
                ) : null}
              </TableCell>
            );
          })}
        </TableRow>
      )}
    </TableHead>
  );
}
